export default __webpack_public_path__ + "static/media/white-top-logo-wshadow.c3378d1b.svg";